import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '.';

export const selectMessages = createSelector(
  (state: RootState) => state.i18n.messages,
  (state: RootState) => state.i18n.language,
  (messages, language) => messages[language],
);
